module.exports = __webpack_public_path__ + "static/img/login.ea67a13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login.png
// module id = 6QGk
// module chunks = 3